
const WorksID2021 = [
      {
        id: 1,
        name: '旅先の日常',
        category: 'interior',
        author: '濱田 朋佳',
        image: '/oitid/student/assets/images/project/2021/id_exercise/03.jpg',
        background: '/oitid/student/assets/images/project/2021/id_exercise/03.jpg',
        presentationImage: [
          '/project/2021/id_exercise/03.jpg',
        ],
        galleryImage: [],
      },
      {
        id: 2,
        name: '私色の町',
        category: 'interior',
        author: '小泉 未来',
        image: '/oitid/student/assets/images/project/2021/id_exercise/01.jpg',
        background: '/oitid/student/assets/images/project/2021/id_exercise/01.jpg',
        presentationImage: [
          '/project/2021/id_exercise/01.jpg',
        ],
        galleryImage: [],
      },
      {
        id: 3,
        name: 'スーパーマーケット x 菜園',
        category: 'interior',
        author: '津田樹央',
        image: '/oitid/student/assets/images/project/2021/id_exercise/02.jpg',
        background: '/oitid/student/assets/images/project/2021/id_exercise/02.jpg',
        presentationImage: [
          '/project/2021/id_exercise/02.jpg',
        ],
        galleryImage: [],
      },
      {
        id: 4,
        name: '街の星空',
        category: 'interior',
        author: '保田 美月',
        image: '/oitid/student/assets/images/project/2021/id_exercise/04.jpg',
        background: '/oitid/student/assets/images/project/2021/id_exercise/04.jpg',
        presentationImage: [
          '/project/2021/id_exercise/04.jpg',
        ],
        galleryImage: [],
      },
      {
        id: 5,
        name: 'Captivate 人を虜にするスーパーマーケット',
        category: 'interior',
        author: '山下 浩奈',
        image: '/oitid/student/assets/images/project/2021/id_exercise/05.jpg',
        background: '/oitid/student/assets/images/project/2021/id_exercise/05.jpg',
        presentationImage: [
          '/project/2021/id_exercise/05.jpg',
        ],
        galleryImage: [],
      },

]

export default WorksID2021